export default "__VITE_ASSET__e2ea3c8f__"